// ................UrlLocalConfig...................

// import { createUrlConfig } from "../localUrlConfig";

// ................urlConfig...................

import { createUrlConfig } from "./urlConfig";

export { BANK_LIST_PATH as imageUrlConfig } from "@/app/utils/config";

// ----------------------------Funcation---------------------------------------------

const u = () => createUrlConfig();

// ----------------------------aiEndPoints points-------------------------------------

export const aiEndPoints = {
  get gxAihealth() {
    return `${u().aiUrlConfig}ai/health`;
  },
  get gxAiquery() {
    return `${u().aiUrlConfig}ai/query/stream`;
  },
  
};

// ----------------------------onboarding end points-------------------------------------

export const authEndPoints = {
  get growxfeeview() {
    return `${u().loginUrlConfig}customers/sme/users/pre-auth/fee/view`;
  },
  get growxfeecreate() {
    return `${u().loginUrlConfig}customers/sme/pre-auth/create`;
  },
  get growxfeeupload() {
    return `${u().loginUrlConfig}customers/sme/pre-auth/file/upload`;
  },
  get growxvalidate() {
    return `${u().loginUrlConfig}customers/sme/pre-auth/validate`;
  },
  get growxcontactvalidate() {
    return `${u().loginUrlConfig}customers/sme/users/pre-auth/contact/validate`;
  },
  get growxglobalcountry() {
    return `${u().loginUrlConfig}customers/sme/users/pre-auth/global-country/list`;
  },
  get growxsupportcountry() {
    return `${u().loginUrlConfig}customers/sme/pre-auth/support/country/list`;
  },
  get growxcompanycheck() {
    return `${u().loginUrlConfig}customers/sme/users/pre-auth/company/check`;
  },
  get growxstatusupdate() {
    return `${u().loginUrlConfig}customers/sme/users/pre-auth/status/update`;
  },
  get growxregister() {
    return `${u().loginUrlConfig}customers/sme/users/pre-auth/register/view`;
  },

  get growxfeeviewtab() {
    return `${u().loginUrlConfig}customers/sme/users/pre-auth/fee/view-summary`;
  },
  get growxterms() {
    return `${u().loginUrlConfig}customers/sme/users/pre-auth/gx-lookups`;
  },

  get growxverifykfc() {
    return `${u().loginUrlConfig}customers/sme/users/pre-auth/kyc/verify`;
  },

  get gxindustrieslist() {
    return `${u().loginUrlConfig}customers/sme/pre-auth/industries/list `;
  },
  get gxsubsectorslist() {
    return `${u().loginUrlConfig}customers/sme/pre-auth/sub-sectors/list `;
  },
};

// ----------------------------onboarding end points-------------------------------

export const onboardingEndPoints = {
  get gxloginPassword() {
    return `${u().loginUrlConfig}auth/login-password`;
  },
  get gxrequestLoginOtp() {
    return `${u().loginUrlConfig}auth/requestLoginOtp`;
  },
  get gxverifyLoginOtp() {
    return `${u().loginUrlConfig}auth/verifyLoginOtp`;
  },
  get gxlogout() {
    return `${u().loginUrlConfig}auth/logout`;
  },
  get gxlogintoken() {
    return `${u().loginUrlConfig}customers/oauth/token`;
  },
  get growxsettings() {
    return `${u().loginUrlConfig}customers/growxsettings`;
  },
  get growxchangepassword() {
    return `${u().loginUrlConfig}customers/post-auth/users/password/update`;
  },
  get growxgetsecurityquestions() {
    return `${u().loginUrlConfig}customers/post-auth/security-questions/list`;
  },
  get growxcreatesecurityquestions() {
    return `${u().loginUrlConfig}customers/post-auth/users/security-questions/create`;
  },
  get growxupdatesecurityquestions() {
    return `${u().loginUrlConfig}customers/post-auth/users/security-questions/update`;
  },

  get growxloginconsent() {
    return `${u().accountServiceUrlConfig}accounts/user-access/consent`;
  },
};

// ----------------------------user notification end points-------------------------------------

export const userNotificationEndPoints = {
  get gxnotify() {
    return `${u().NotifiUrlConfig}notify/view-summary`;
  },
  get gxnotifycategory() {
    return `${u().NotifiUrlConfig}notify/category/summary`;
  },
  get gxnotifyupdate() {
    return `${u().NotifiUrlConfig}notify/status/update`;
  },
};

// ----------------------------customeronboardingBankEndPoints-------------------------------------

export const customeronboardingBankEndPoints = {
  get gxStgCreate() {
    return `${u().customerUrlConfig}customers/sme/comp-acc/stg/create`;
  },
};

// ----------------------------appmenuEndPoints-------------------------------------

export const appmenuEndPoints = {
  get gxmenu() {
    return `${u().loginUrlConfig}customers/menus`;
  },
};

// ----------------------------beneficiarypoints-------------------------------------

export const beneficiarypoints = {
  get gxSearchswift() {
    return `${u().paymentUrlConfig}payments/beneficiary/swift-bics/search`;
  },
  get addBeneficiary() {
    return `${u().paymentUrlConfig}payments/beneficiary/create`;
  },
  get updateBeneficiary() {
    return `${u().paymentUrlConfig}payments/beneficiary/update`;
  },
  get deleteBeneficiary() {
    return `${u().paymentUrlConfig}payments/beneficiary/delete`;
  },
  get gxBeneficiaryList() {
    return `${u().paymentUrlConfig}payments/beneficiary/view-summary`;
  },
  get gxBeneficiaryPendingList() {
    return `${u().paymentUrlConfig}payments/beneficiary/pending/view-summary`;
  },
  get gxBeneficiaryDetails() {
    return `${u().paymentUrlConfig}payments/beneficiary/view`;
  },
  get gxBeneficiaryTransactionsSummary() {
    return `${u().paymentUrlConfig}payments/beneficiary/transaction/view-summary`;
  },
  get gxBeneficiaryTransactionDetails() {
    return `${u().paymentUrlConfig}payments/beneficiary/transaction/view`;
  },
  get gxToggleFavourite() {
    return `${u().paymentUrlConfig}payments/beneficiary/favourite`;
  },
  get gxBeneficiaryValidate() {
    return `${u().paymentUrlConfig}payments/beneficiary/iban/validate`;
  },
  get gxBeneficiaryViewSummary() {
    return `${u().paymentUrlConfig}payments/beneficiary/favourite/view-summary`;
  },
  get gxBeneficiaryBulkApprove() {
    return `${u().paymentUrlConfig}payments/beneficiary/bulk-approve`;
  },
  get gxBeneficiaryApprove() {
    return `${u().paymentUrlConfig}payments/beneficiary/approve`;
  },
  get gxBeneficiaryActivationStatus() {
    return `${u().paymentUrlConfig}payments/beneficiary/activation-status`;
  },
  get gxBeneficiaryUpdateElgible() {
    return `${u().paymentUrlConfig}payments/beneficiary/update-elgible`;
  },
  get gxPendingViewSummary() {
    return `${u().paymentUrlConfig}payments/beneficiary/pending/view-summary`;
  },
  get addBeneficiaryConfirmation() {
    return `${u().paymentUrlConfig}payments/beneficiary/confirmation`;
  },
  get gxBeneficiaryCountryCodeIdentifier() {
    return `${u().paymentUrlConfig}payments/beneficiary/country/identifier`;
  },
  get gxBeneficiaryCountry() {
    return `${u().paymentUrlConfig}payments/beneficiary/country/list`;
  },
};

// ----------------------------paymentEndPoints-------------------------------------

export const paymentEndPoints = {
  get gxPaymentTypes() {
    return `${u().paymentUrlConfig}payments/payment-types`;
  },
  get gxPaymentLimits() {
    return `${u().paymentUrlConfig}payments/limits/validate`;
  },
  get gxPaymentCutOff() {
    return `${u().paymentUrlConfig}payments/cut-off/validate`;
  },
  get gxPaymentRegistered() {
    return `${u().paymentUrlConfig}payments/beneficiary/registered/list`;
  },
  get gxPaymentPurposeCodes() {
    return `${u().paymentUrlConfig}payments/purpose-codes`;
  },
  get gxPaymentPendingView() {
    return `${u().paymentUrlConfig}payments/pending/view`;
  },
  get gxPaymentPendingViewSummary() {
    return `${u().paymentUrlConfig}payments/pending/view-summary`;
  },
  get gxPaymentInitiate() {
    return `${u().paymentUrlConfig}payments/initiate`;
  },
  get gxPaymentGxLookups() {
    return `${u().paymentUrlConfig}payments/gx-lookups`;
  },
  get gxPaymentFxRateCalculate() {
    return `${u().paymentUrlConfig}payments/fx-rate/calculate`;
  },
  get gxPaymentDebitAccounts() {
    return `${u().paymentUrlConfig}payments/debit-accounts`;
  },
  get gxPaymentDebitAccountsView() {
    return `${u().paymentUrlConfig}payments/debit-accounts/transactions/view`;
  },
  get gxPaymentDebitAccountsViewSummary() {
    return `${u().paymentUrlConfig}payments/debit-accounts/transactions/view-summary`;
  },
  get gxPaymentDebitAccountsBalance() {
    return `${u().paymentUrlConfig}payments/debit-accounts/balance`;
  },
  get gxPaymentChargeCalculate() {
    return `${u().paymentUrlConfig}payments/charges/calculate`;
  },
  get gxPaymentBulkApprove() {
    return `${u().paymentUrlConfig}payments/bulk-approve`;
  },
  get gxPaymentBankCurrencies() {
    return `${u().paymentUrlConfig}payments/bank-currencies`;
  },
  get gxPaymentApprove() {
    return `${u().paymentUrlConfig}payments/approve`;
  },
  get gxPaymentFxQuotesRetrieve() {
    return `${u().paymentUrlConfig}payments/fx-quote/retrieve`;
  },
  get gxPaymentFxQuotesCreate() {
    return `${u().paymentUrlConfig}payments/fx-quote/create`;
  },
  get gxPaymentFxQuotesAccept() {
    return `${u().paymentUrlConfig}payments/fx-quote/accept`;
  },
  get gxPaymentCancelTransaction() {
    return `${u().paymentUrlConfig}payments/cancel/transactions`;
  },
  get gxPaymentScheduleDetails() {
    return `${u().paymentUrlConfig}payments/dashboard/so/transactions/view`;
  },
  get pollingCheck() {
    return `${u().paymentUrlConfig}payments/polling-check`;
  },
  get gxAllCbTransfers() {
    return `${u().paymentUrlConfig}payments/dashboard/so/cbs/transactions/view-summary`;
  },
  get gxAllCbSchedule() {
    return `${u().paymentUrlConfig}payments/dashboard/so/cbs/view-summary`;
  },
  get gxSendForRepairList() {
    return `${u().paymentUrlConfig}payments/dashboard/repair/view-summary`;
  },
  get gxReSubmitConsent() {
    return `${u().paymentUrlConfig}payments/repair/submit`;
  },
  get gxGetBeneficiaryList() {
    return `${u().paymentUrlConfig}payments/dashboard/so/beneficiary/list`;
  },
  get gxGetScheduleView() {
    return `${u().paymentUrlConfig}payments/dashboard/so/transactions/view-summary`;
  },
  get gxGetCountries() {
    return `${u().paymentUrlConfig}payments/supported/country/list`;
  },
  get gxConfirmBeneficiary() {
    return `${u().paymentUrlConfig}payments/beneficiary/confirmation`;
  },
  get gxGenerateOtp() {
    return `${u().paymentUrlConfig}payments/otp/generate`;
  },
  get gxRecentBeneficiary() {
    return `${u().paymentUrlConfig}payments/aani/beneficiaries/recent`;
  },
  get gxVerifyGOTP() {
    return `${u().paymentUrlConfig}payments/google/otp/validate`;
  },
  get gxVerifyOTP() {
    return `${u().paymentUrlConfig}payments/otp/validate`;
  },
  get gxNonce() {
    return `${u().paymentUrlConfig}payments/nonce/initiate`;
  },
  get gxApproveNonce() {
    return `${u().paymentUrlConfig}payments/nonce/approve`;
  },
  get gxPaymentBeneficiaryDetails() {
    return `${u().paymentUrlConfig}payments/beneficiary/view`;
  },
  get gxCentranBankAccount() {
    return `${u().paymentUrlConfig}payments/debit-accounts/delegated-authority`;
  },
  get gxRTPPaymentApprovalList() {
    return `${u().paymentUrlConfig}payments/pending/view-summary-rtp`;
  },
};

// ----------------------------dashboardEndPoints-------------------------------------

export const dashboardEndPoints = {
  get gxDashboardScheduledViewSummary() {
    return `${u().paymentUrlConfig}payments/dashboard/so/view-summary`;
  },
  get gxDashboardScheduled() {
    return `${u().paymentUrlConfig}payments/dashboard/so/transactions/view-summary`;
  },
  get gxDashboardImmediateAttention() {
    return `${u().paymentUrlConfig}payments/dashboard/immediate-attention`;
  },
  get gxDashboardHistoryRecent() {
    return `${u().paymentUrlConfig}payments/dashboard/transactions/recent`;
  },
  get gxDashboardApprovalsPendingCount() {
    return `${u().paymentUrlConfig}payments/dashboard/pending/count`;
  },
  get gxDashboardTopBeneficiariesGraph() {
    return `${u().paymentUrlConfig}payments/dashboard/graph/beneficiaries/top`;
  },
  get gxDashboardQuickTransferSummary() {
    return `${u().paymentUrlConfig}payments/dashboard/quick-transfer/view-summary`;
  },
  get gxDashboardPaymentByMonthChart() {
    return `${u().paymentUrlConfig}payments/dashboard/chart/top-by-frequency`;
  },
};

// ----------------------------accountLiabilitiesEndPoints-------------------------------------

export const accountLiabilitiesEndPoints = {
  get gxLiabilitiesLoan() {
    return `${u().accountServiceUrlConfig}accounts/liabilities/loan`;
  },
  get gxLiabilitiesLoanBalance() {
    return `${u().accountServiceUrlConfig}accounts/liabilities/loan/balance`;
  },
  get gxLiabilitiesLoanActivities() {
    return `${u().accountServiceUrlConfig}accounts/liabilities/loan/activities`;
  },
  get gxLiabilitiesLoanSummary() {
    return `${u().accountServiceUrlConfig}accounts/liabilities/loan-summary`;
  },
  get gxLiabilitiesCard() {
    return `${u().accountServiceUrlConfig}accounts/liabilities/card`;
  },
  get gxLiabilitiesCardSummary() {
    return `${u().accountServiceUrlConfig}accounts/liabilities/card-summary`;
  },
  get gxLiabilitiesCardActivities() {
    return `${u().accountServiceUrlConfig}accounts/liabilities/card/activities`;
  },
  get gxGetLoanPayNowInfo() {
    return `${u().accountServiceUrlConfig}accounts/liabilities/loan/paynow`;
  },
  get gxAccountSubfeature() {
    return `${u().accountServiceUrlConfig}accounts/subfeatures`;
  },
};

// ----------------------------accountStatementEndPoints-------------------------------------

export const accountStatementEndPoints = {
  get gxStatementGxlookups() {
    return `${u().accountServiceUrlConfig}accounts/gx-lookups`;
  },
  get gxCasaStatementRequest() {
    return `${u().accountServiceUrlConfig}accounts/assets/casa/statement/request`;
  },
  get gxStatementSummary() {
    return `${u().accountServiceUrlConfig}accounts/assets/casa/statement-summary`;
  },
  get gxStatementSummaryDownload() {
    return `${u().accountServiceUrlConfig}accounts/assets/casa/statement-summary/download`;
  },
};

// ----------------------------accountServiceRequestEndPoints-------------------------------------

export const accountServiceRequestEndPoints = {
  get gxServiceRequestChequebookType() {
    return `${u().accountServiceUrlConfig}accounts/gx-lookups/chequebooktype`;
  },
  get gxServiceRequestChequebookLeaves() {
    return `${u().accountServiceUrlConfig}accounts/gx-lookups/chequebookleaves`;
  },
  get gxServiceRequestChequebookDeliveryType() {
    return `${u().accountServiceUrlConfig}accounts/gx-lookups/chequebookdeliverytype`;
  },
  get gxServiceRequestChequebook() {
    return `${u().accountServiceUrlConfig}accounts/gx-lookups/chequebook`;
  },
  get gxServiceRequestBalanceConfirmation() {
    return `${u().accountServiceUrlConfig}accounts/gx-lookups/balanceconfirmation`;
  },
  get gxServiceRequestChequeBooks() {
    return `${u().accountServiceUrlConfig}accounts/assets/cheque-books/request`;
  },
  get gxServiceRequestBalanceConfirmRequest() {
    return `${u().accountServiceUrlConfig}accounts/assets/balance-confirm/request`;
  },
};

// ----------------------------accountpoints-------------------------------------

export const accountpoints = {
  get gxAccountUpdateFavouriteAccounts() {
    return `${u().accountServiceUrlConfig}accounts/update/favourite-accounts`;
  },
  get gxAccountFavouriteAccounts() {
    return `${u().accountServiceUrlConfig}accounts/favourite-accounts`;
  },
  get gxAccountBalanceTotal() {
    return `${u().accountServiceUrlConfig}accounts/balance/total`;
  },
  get gxAccountBankCurrency() {
    return `${u().accountServiceUrlConfig}accounts/bank-currencies`;
  },
  get gxAccountHistoryRecent() {
    return `${u().accountServiceUrlConfig}accounts/history/recent`;
  },
  get gxAccountImmediateAttention() {
    return `${u().accountServiceUrlConfig}accounts/immediate-attention`;
  },
};

// ----------------------------accountServiceAssetsEndPoints-------------------------------------

export const accountServiceAssetsEndPoints = {
  get gxAssetsDeposit() {
    return `${u().accountServiceUrlConfig}accounts/assets/deposit`;
  },
  get gxAssetsDepositBalance() {
    return `${u().accountServiceUrlConfig}accounts/assets/deposit/balance`;
  },
  get gxAssetsDepositActivities() {
    return `${u().accountServiceUrlConfig}accounts/assets/deposit/activities`;
  },
  get gxAssetsDepositSummary() {
    return `${u().accountServiceUrlConfig}accounts/assets/deposit-summary`;
  },
  get gxAssetsDebitAccountView() {
    return `${u().accountServiceUrlConfig}accounts/assets/debit-accounts/view`;
  },
  get gxAssetsDebitAccountViewSummary() {
    return `${u().accountServiceUrlConfig}accounts/assets/debit-accounts/view-summary`;
  },
  get gxAssetsCasa() {
    return `${u().accountServiceUrlConfig}accounts/assets/casa`;
  },
  get gxAssetsCasaBalance() {
    return `${u().accountServiceUrlConfig}accounts/assets/casa/balance`;
  },
  get gxAssetsCasaActivities() {
    return `${u().accountServiceUrlConfig}accounts/assets/casa/activities`;
  },
  get gxAssetsCasaActivitiesTracker() {
    return `${u().accountServiceUrlConfig}accounts/assets/casa/activities-tracker`;
  },
  get gxAssetsCasaSummary() {
    return `${u().accountServiceUrlConfig}accounts/assets/casa-summary`;
  },
  get gxAccountsBanklist() {
    return `${u().accountServiceUrlConfig}accounts/banks/list`;
  },
};

// ----------------------------customerUserRoleEndPoints-------------------------------------

export const customerUserRoleEndPoints = {
  get gxUserRolePut() {
    return `${u().customerUrlConfig}customers/user-role/update`;
  },
  get gxUserRolePost() {
    return `${u().customerUrlConfig}customers/user-role/create`;
  },
  get gxUserRoleSmeCompanyId() {
    return `${u().customerUrlConfig}customers/user-role/company-userrole-by-sme-company-id`;
  },
  get gxUserRoleGet() {
    return `${u().customerUrlConfig}customers/user-role/{id}`;
  },
  get gxUserRoleAllGet() {
    return `${u().customerUrlConfig}customers/user-role/all`;
  },
  get growxpreferencelist() {
    return `${u().customerUrlConfig}customers/sme/users/notify/preference/list`;
  },
  get growxpreferencecreate() {
    return `${u().customerUrlConfig}customers/sme/users/notify/preference/create`;
  },
};

// ----------------------------customerSysQuestEndPoints-------------------------------------

export const customerSysQuestEndPoints = {
  get gxSecQuestionsUpdate() {
    return `${u().customerUrlConfig}customers/sys-security-questions/update`;
  },
  get gxSecQuestionsCreate() {
    return `${u().customerUrlConfig}customers/sys-security-questions/create`;
  },
  get gxSecQuestionsShow() {
    return `${u().customerUrlConfig}customers/sys-security-questions/view-summary`;
  },
  get gxSecQuestionsShowId() {
    return `${u().customerUrlConfig}customers/sys-security-questions/view-summary/{id}`;
  },
};

// ----------------------------customerSysPortalEndPoints-------------------------------------

export const customerSysPortalEndPoints = {
  get gxPortalUpdate() {
    return `${u().customerUrlConfig}customers/sys-portal/update`;
  },
  get gxPortalCreate() {
    return `${u().customerUrlConfig}customers/sys-portal/create`;
  },
  get gxPortalShow() {
    return `${u().customerUrlConfig}customers/sys-portal/show`;
  },
  get gxPortalShowId() {
    return `${u().customerUrlConfig}customers/sys-portal/show/{id}`;
  },
};

// ----------------------------customerSysModuleEndPoints-------------------------------------

export const customerSysModuleEndPoints = {
  get gxModuleUpdate() {
    return `${u().customerUrlConfig}customers/sys-module/update`;
  },
  get gxModuleCreate() {
    return `${u().customerUrlConfig}customers/sys-module/create`;
  },
  get gxModuleShow() {
    return `${u().customerUrlConfig}customers/sys-module/show`;
  },
  get gxModuleShowId() {
    return `${u().customerUrlConfig}customers/sys-module/show/{id}`;
  },
  get gxModulePortalId() {
    return `${u().customerUrlConfig}customers/sys-module/portal-id/{portalId}`;
  },
};

// ----------------------------customerSysMenuEndPoints-------------------------------------

export const customerSysMenuEndPoints = {
  get gxMenuUpdate() {
    return `${u().customerUrlConfig}customers/sys-menu/update`;
  },
  get gxMenuCreate() {
    return `${u().customerUrlConfig}customers/sys-menu/create`;
  },
  get gxMenuId() {
    return `${u().customerUrlConfig}customers/sys-menu/show`;
  },
  get gxMenuShowId() {
    return `${u().customerUrlConfig}customers/sys-menu/show/{id}`;
  },
  get gxMenuModuleId() {
    return `${u().customerUrlConfig}customers/sys-menu/module/{moduleId}`;
  },
};

// ----------------------------customerSysSubFeatureEndPoints-------------------------------------

export const customerSysSubFeatureEndPoints = {
  get gxSysSubFeatureEditId() {
    return `${u().customerUrlConfig}customers/subfeature/edit/{id}`;
  },
  get gxSysSubFeature() {
    return `${u().customerUrlConfig}customers/subfeature/create`;
  },
  get gxSysSubFeatureShow() {
    return `${u().customerUrlConfig}customers/subfeature/show`;
  },
  get gxSysSubFeatureShowId() {
    return `${u().customerUrlConfig}customers/subfeature/show/{id}`;
  },
  get gxSysSubFeatureActivityId() {
    return `${u().customerUrlConfig}customers/subfeature/activity-id/{activityId}`;
  },
};

// ----------------------------customerAppStatusEndPoints-------------------------------------

export const customerAppStatusEndPoints = {
  get gxAppStatus() {
    return `${u().customerUrlConfig}customers/system/app-status`;
  },
};

// ----------------------------globalCountryEndPoints-------------------------------------

export const globalCountryEndPoints = {
  get gxGlobalCountry() {
    return `${u().customerUrlConfig}customers/sys-global-country/view-summary`;
  },
};

// ----------------------------customerUserEndPoints-------------------------------------

export const customerUserEndPoints = {
  get gxUserList() {
    return `${u().customerUrlConfig}customers/sme/users/view-summary`;
  },
  get gxUserview() {
    return `${u().customerUrlConfig}customers/sme/users/view`;
  },
  get gxUserupdate() {
    return `${u().customerUrlConfig}customers/sme/users/update`;
  },
  get gxFeaturesList() {
    return `${u().customerUrlConfig}customers/sme/users/bank/features`;
  },
  get gxCompanyview() {
    return `${u().customerUrlConfig}customers/sme/users/company-view`;
  },
  get gxSmeGlobalCountry() {
    return `${u().customerUrlConfig}customers/sme/users/global-country/list`;
  },

  get gxCompanyUpdate() {
    return `${u().customerUrlConfig}customers/sme/company-info/update`;
  },
  get gxtradeLicense() {
    return `${u().customerUrlConfig}customers/sme/company-info/update/tradeLicense`;
  },
  get gxfileUpload() {
    return `${u().customerUrlConfig}customers/sme/trade-license/file/upload`;
  },
  get gxfileview() {
    return `${u().customerUrlConfig}customers/sme/documents/view `;
  },
  get gxBanklist() {
    return `${u().customerUrlConfig}customers/sme/banks/list`;
  },

  get gxAuthBanklist() {
    return `${u().customerUrlConfig}customers/authmatrix/bank/list`;
  },
  get gxBankAccountlist() {
    return `${u().customerUrlConfig}customers/sme/banks/account/view/summary`;
  },
  get gxBankAccountDelete() {
    return `${u().customerUrlConfig}customers/sme/banks/account/delete`;
  },
  get gxBankAccountActivationState() {
    return `${u().customerUrlConfig}customers/sme/banks/account/activation-status`;
  },
  get gxaccountpermissionlist() {
    return `${u().customerUrlConfig}consents/account/permi/list`;
  },
  get gxcbspermissionlist() {
    return `${u().customerUrlConfig}customers/cbs/permission/list`;
  },
  get gxUserActivityStatus() {
    return `${u().customerUrlConfig}customers/sme/users/activation-status`;
  },
  get gxUserActivityStatusDelete() {
    return `${u().customerUrlConfig}customers/sme/users/delete`;
  },
  get gxThirdPartyFeatureList() {
    return `${u().customerUrlConfig}customers/sme/third-party/feature/list`;
  },
  get gxThirdPartySubFeatureList() {
    return `${u().customerUrlConfig}customers/sme/third-party/sub-feature/list`;
  },
  get gxThirdPartyFeatureUpdate() {
    return `${u().customerUrlConfig}customers/sme/third-party/update`;
  },

  get gxThirdPartySubFeatureView() {
    return `${u().customerUrlConfig}customers/sme/third-party/sub-feature/view`;
  },
  get gxThirdPartyMenuList() {
    return `${u().customerUrlConfig}customers/sme/third-party/view-summary`;
  },
  get gxSendToOwner() {
    return `${u().customerUrlConfig}customers/sme/users/self/onboard/status/update`;
  },
  get gxredirectbank() {
    return `${u().customerUrlConfig}consents/cbs/redirect-url`;
  },
  get gxcompanycheck() {
    return `${u().customerUrlConfig}customers/sme/users/self/onboard/company/check`;
  },
  get gxsmeuserLookups() {
    return `${u().customerUrlConfig}customers/sme/users/gx-lookups`;
  },
  get gxSmeFileUpload() {
    return `${u().customerUrlConfig}customers/sme/file/upload`;
  },
  get gxSmeUsersCompanyProfileUpdate() {
    return `${u().customerUrlConfig}customers/sme/users/company-profile/update`;
  },
  get gxsmeuserreport() {
    return `${u().customerUrlConfig}customers/sme/users/report`;
  },
  get gxsmefetchreport() {
    return `${u().customerUrlConfig}customers/users/fetch/report`;
  },
  get gxsmeuserfeedback() {
    return `${u().customerUrlConfig}customers/sme/users/feedback`;
  },
  get gxsmefetchfeedback() {
    return `${u().customerUrlConfig}customers/users/fetch/feedback`;
  },

  get gxsmeprofileview() {
    return `${u().customerUrlConfig}customers/sme/users/documents/view`;
  },

  get gxsmeprofileupload() {
    return `${u().customerUrlConfig}customers/sme/users/file/upload`;
  },
};

// ----------------------------LFIEndPoints-------------------------------------

export const LFIEndPoints = {
  get gxpar() {
    return `${u().consentConfig}consents/users/banks/account/create`;
  },

  get gxredirect() {
    return `${u().consentConfig}consents/cbs/redirect-url`;
  },

  get pollingCheck() {
    return `${u().customerUrlConfig}customers/users-consent-account/polling-check`;
  },
};

// ----------------------------selfOnboardEndPoints-------------------------------------

export const selfOnboardEndPoints = {
  get gxSelfOnboard() {
    return `${u().customerLocalUrlConfig}customers/sme/users/self/onboard/pending/view-summary`;
  },
  get gxCompanyRoleAll() {
    return `${u().customerLocalUrlConfig}customers/role/sme/view-summary`;
  },
  get gxlookupType() {
    return `${u().customerLocalUrlConfig}customers/system/gx-lookups`;
  },
  get gxSelfOnboardUpdate() {
    return `${u().customerLocalUrlConfig}customers/sme/users/self/onboard/approve`;
  },
  get gxSmeFeaturesList() {
    return `${u().customerUrlConfig}customers/sme/users/features`;
  },
  get gxSmeFeaturesAccountList() {
    return `${u().customerUrlConfig}customer/sme/features/account/list`;
  },
  get gxSmeAccountsFeaturesList() {
    return `${u().customerUrlConfig}customers/sme/users/feature/accounts`;
  },
  get gxSmeManageAccountsFeaturesList() {
    return `${u().customerUrlConfig}customers/sme/users/bank/features/accounts`;
  },
  get gxSelfOnboardView() {
    return `${u().customerLocalUrlConfig}customers/sme/users/self/onboard/pending/view`;
  },
  get gxSelfOnboardReject() {
    return `${u().customerLocalUrlConfig}customers/sme/users/self/onboard/reject`;
  },
  get gxSelfOnboardUsingDefaults() {
    return `${u().customerLocalUrlConfig}customers/sme/users/onboard/using-default`;
  },
  get gxKycFileUpload() {
    return `${u().onboardConfig}customers/postauth/uae-emirates-v2`;
  },
  get gxGetCountriesManageUser() {
    return `${u().customerUrlConfig}customers/sme/users/bank/list`;
  },
};

// ----------------------------manageConsentsEndPoints-------------------------------------

export const manageConsentsEndPoints = {
  get gxConsentCrtList() {
    return `${u().consentConfig}consents/data-sharing/current/view-summary`;
  },

  get gxConsentHtyList() {
    return `${u().consentConfig}consents/data-sharing/history/view-summary`;
  },
  get gxConsentCrtView() {
    return `${u().consentConfig}consents/data-sharing/current/view`;
  },
  get gxConsentCutList() {
    return `${u().consentConfig}consents/service-initiation/current/view`;
  },
  get gxConsentHtyView() {
    return `${u().consentConfig}consents/data-sharing/history/view`;
  },
  get gxConsentCrtUpdList() {
    return `${u().consentConfig}consents/data-sharing/hierarchy`;
  },

  // ............................

  get gxConsentPermissionList() {
    return `${u().consentConfig}consents/data-cluster/permissions/list`;
  },

  // ulla

  // get gxConsentPermissionList() {
  //   return `${u().consentConfig}consents/users/data-cluster/permissions/list`;
  // },

  get gxConsentBankList() {
    return `${u().consentConfig}consents/users/banks/list`;
  },
  get gxDSConsentBankList() {
    return `${u().consentConfig}consents/users/banks/list`;
  },
  get gxConsentPermissionCbList() {
    return `${u().consentConfig}consents/data-cluster/permissions/list`;
  },
  get gxConsentActivationStatusList() {
    return `${u().consentConfig}consents/activation-status`;
  },
  get gxConsentAccountPermissionList() {
    return `${u().consentloginConfig}consents/data-cluster/permissions/list`;
  },
  get gxConsentDelegated() {
    return `${u().consentloginConfig}consents/users/delegated/list`;
  },
  get gxConsentAdminList() {
    return `${u().consentloginConfig}consents/users/admin/list`;
  },
  get gxConsentAccountDetailList() {
    return `${u().consentloginConfig}consents/data-sharing/accounts/list`;
  },
  get gxConsentServiceInitiationCrtList() {
    return `${u().consentConfig}consents/service-initiation/current/view-summary`;
  },
  get gxConsentServiceInitiationHtyList() {
    return `${u().consentConfig}consents/service-initiation/history/view-summary`;
  },
  get gxConsentPaymentDetailList() {
    return `${u().consentConfig}consents/service-initiation/payment/details`;
  },
  get gxConsentPaymentHistoryList() {
    return `${u().consentConfig}consents/service-initiation/payment/history`;
  },
  get gxConsentRevoke() {
    return `${u().consentConfig}consents/data-sharing/revoke`;
  },
  get gxConsentCancelPermissionRevoke() {
    return `${u().consentConfig}consents/service-initiation/so/payment/revoke`;
  },

  get gxConsentStagingAccounts() {
    return `${u().consentConfig}consents/company/staging-accounts`;
  },

  get gxConsentAccountsCheck() {
    return `${u().consentConfig}consents/account/check`;
  },
};

// ----------------------------ConsentLFIEndPoints-------------------------------------

export const ConsentLFIEndPoints = {
  get gxpar() {
    return `${u().consentConfig}consents/users/banks/account/create`;
  },
  get pollingCheck() {
    return `${u().consentPollingConfig}consents/polling-check`;
  },
  get consentaccountdetail() {
    return `${u().consentConfig}consents/data-sharing/accounts/list`;
  },
  get consentCbsRedirectUrl() {
    return `${u().consentConfig}consents/cbs/redirect-url`;
  },
};

// ----------------------------adminMenuAuthMatrixEndPoints-------------------------------------

export const adminMenuAuthMatrixEndPoints = {
  get gxAuthMatrixUserIdSummary() {
    return `${u().customerUrlConfig}customers/authmatrix/payment-type/by-userId/view-summary`;
  },
  get gxAuthMatrixPaymenttypeId() {
    return `${u().customerUrlConfig}customers/authmatrix/payment-type/paymentTypeId/view`;
  },
  get gxAuthMatrixCreate() {
    return `${u().customerUrlConfig}customers/authmatrix/create`;
  },
  get gxAuthMatrixUpdate() {
    return `${u().customerUrlConfig}customers/authmatrix/update`;
  },
  get gxAuthMatrixDelete() {
    return `${u().customerUrlConfig}customers/authmatrix/delete`;
  },
  get gxAuthMatrixViewSummary() {
    return `${u().customerUrlConfig}customers/authmatrix/payment-type/list`;
  },
  // get gxAuthMatrixAccountsList() {
  //   return `${u().customerUrlConfig}customers/authmatrix/accounts/list`;
  // },

  get gxAuthMatrixAccountsList() {
    return `${u().customerUrlConfig}customers/authmatrix/accounts/list`;
  },

  get gxAuthMatrixView() {
    return `${u().customerUrlConfig}customers/authmatrix/view`;
  },

  get gxAuthMatrixGroupCreate() {
    return `${u().customerUrlConfig}customers/authmatrix/group/create`;
  },

  get gxAuthMatrixGroupView() {
    return `${u().customerUrlConfig}customers/authmatrix/group/view-summary`;
  },

  get gxAuthMatrixGroupDelete() {
    return `${u().customerUrlConfig}customers/authmatrix/group/delete`;
  },

  get gxAuthMatrixPermissionValidate() {
    return `${u().customerUrlConfig}customers/authmatrix/validate/approval/permission`;
  },

  get gxAuthMatrixRolePermissionValidate() {
    return `${u().customerUrlConfig}customers/authmatrix/validate/role/permission`;
  },

  get gxAuthMatrixGroupValidateDelete() {
    return `${u().customerUrlConfig}customers/authmatrix/group/validate/delete`;
  },
};

// ----------------------------adminMenuInviteUserEndPoints-------------------------------------

export const adminMenuInviteUserEndPoints = {
  get gxInviteUserView() {
    return `${u().customerUrlConfig}customers/sme/users/invite/view`;
  },
  get gxInviteUserfeaturesDtoView() {
    return `${u().customerUrlConfig}customers/users/workflow/features/view`;
  },
  get gxInviteResendInvite() {
    return `${u().customerUrlConfig}customers/sme/users/invite/resend`;
  },
  get gxInviteWorkflowView() {
    return `${u().customerUrlConfig}customers/users/workflow/accounts/view`;
  },
  get gxInviteList() {
    return `${u().customerUrlConfig}customers/sme/users/invite/view-summary`;
  },
  get gxInviteDelete() {
    return `${u().customerUrlConfig}customers/sme/users/invite/delete`;
  },
  get gxInviteCreate() {
    return `${u().customerUrlConfig}customers/sme/users/invite/create`;
  },
  get gxInviteDefault() {
    return `${u().customerUrlConfig}customers/sme/users/onboard/using-default`;
  },
  get gxInviteCountryList() {
    return `${u().customerUrlConfig}customers/sme/country/list`;
  },
  get gxInviteEmailVerify() {
    return `${u().customerUrlConfig}customers/sme/validate/email`;
  },
  get gxInviteFeaturesView() {
    return `${u().customerUrlConfig}customers/sme/users/invite/features`;
  },
  get gxInviteAccountView() {
    return `${u().customerUrlConfig}customers/sme/users/invite/feature/accounts`;
  },
  get gxSmeUserBankList() {
    return `${u().customerUrlConfig}customers/sme/users/bank/list`;
  },
  get gxSmeUserInviteBankList() {
    return `${u().customerUrlConfig}customers/sme/users/invite/banks/list`;
  },
  get gxkycdocumentupload() {
    return `${u().customerUrlConfig}customers/sme/users/kyc/verify`;
  },
  get gxContactValidate() {
    return `${u().customerUrlConfig}customers/sme/users/contact/validate`;
  },
  get gxRolePermisions() {
    return `${u().customerUrlConfig}customers/role/menu/permissions`;
  },
};

// ----------------------------rtpServiceEndPoints-------------------------------------

export const rtpServiceEndPoints = {
  get gxRtpGetUserList() {
    return `${u().rtpServiceUrlConfig}collections/rtp/payers/list`;
  },
  get gxRtpGetDepositAccounts() {
    return `${u().rtpServiceUrlConfig}collections/rtp/deposit-accounts`;
  },
  get gxRtpSubmit() {
    return `${u().rtpServiceUrlConfig}collections/rtp/initiate?event=create`;
  },
  get gxRtpFilter() {
    return `${u().rtpServiceUrlConfig}collections/rtp/search`;
  },
  get gxRtpSavePayerSubmit() {
    return `${u().rtpServiceUrlConfig}collections/rtp/initiate?event=create`;
  },
  get gxOnlyRtpSubmit() {
    return `${u().rtpServiceUrlConfig}collections/rtp/initiate?event=create`;
  },
  get gxRtpViewIndividual() {
    return `${u().rtpServiceUrlConfig}collections/rtp/view`;
  },
  get gxRtpViewSummary() {
    return `${u().rtpServiceUrlConfig}collections/rtp/view-summary`;
  },
  get gxRtpDuplicate() {
    return `${u().rtpServiceUrlConfig}collections/rtp/clone`;
  },
  get gxRtpCancelled() {
    return `${u().rtpServiceUrlConfig}collections/rtp/cancel`;
  },
  get gxRtpDashboardGetOverdue() {
    return `${u().rtpServiceUrlConfig}collections/rtp/dashboard/overdue`;
  },
  get gxRtpDashboardRtpTrends() {
    return `${u().rtpServiceUrlConfig}collections/rtp/dashboard/trends`;
  },
  get gxRtpDashboardTodayRequest() {
    return `${u().rtpServiceUrlConfig}collections/rtp/dashboard/today-requests`;
  },
  get gxRtpDashboardUnpaidSummary() {
    return `${u().rtpServiceUrlConfig}collections/rtp/dashboard/unpaid/summary`;
  },
  get gxRtpDashboardRtpAging() {
    return `${u().rtpServiceUrlConfig}collections/rtp/dashboard/aging`;
  },
  get gxRtpRtpNounce() {
    return `${u().rtpServiceUrlConfig}collections/rtp/nonce/initiate`;
  },
  get gxRtpRecentPayers() {
    return `${u().rtpServiceUrlConfig}collections/rtp/recent/payers`;
  },
  get gxVerifyPayer() {
    return `${u().rtpServiceUrlConfig}collections/rtp/payers/verify-growx-user`;
  },
  get gxNotifiedRequest() {
    return `${u().rtpServiceUrlConfig}collections/rtp/payers/user-details`;
  },
  get gxRequestDetails() {
    return `${u().rtpServiceUrlConfig}collections/rtp/transaction/details`;
  },
  get gxViewReceipt() {
    return `${u().rtpServiceUrlConfig}collections/rtp/transaction/receipt`;
  },
  get gxDownloadReceipt() {
    return `${u().rtpServiceUrlConfig}collections/rtp/transaction/receipt`;
  },
  get gxRTPRequest() {
    return `${u().paymentUrlConfig}collections/rtp/reject`;
  },
  get gxResendRTPRequest() {
    return `${u().paymentUrlConfig}collections/rtp/resend`;
  },
};

// ----------------------------payerServiceEndPoints-------------------------------------

export const payerServiceEndPoints = {
  get gxPayerGetViewSummary() {
    return `${u().rtpServiceUrlConfig}collections/payer/view-summary`;
  },
  get gxPayerViewDetails() {
    return `${u().rtpServiceUrlConfig}collections/payer/view`;
  },
  get gxPayerAddNewPayer() {
    return `${u().rtpServiceUrlConfig}collections/payer/create`;
  },
  get gxPayerEditPayer() {
    return `${u().rtpServiceUrlConfig}collections/payer/update`;
  },
  get gxPayerDeletePayer() {
    return `${u().rtpServiceUrlConfig}collections/payer/delete`;
  },
  get gxPayerViewTransaction() {
    return `${u().rtpServiceUrlConfig}collections/payer/transaction/view-summary`;
  },
  get gxPayerViewPendingSummary() {
    return `${u().rtpServiceUrlConfig}collections/payer/pending/view-summary`;
  },
  get gxPayerApprovalReject() {
    return `${u().rtpServiceUrlConfig}collections/payer/approve`;
  },
  get gxPayerBulkApprovalReject() {
    return `${u().rtpServiceUrlConfig}collections/payer/bulk-approve`;
  },
  get gxPayerCountryList() {
    return `${u().rtpServiceUrlConfig}collections/payer/country/list`;
  },
};

// ----------------------------bulkPaymentsPayrollServiceEndPoints-------------------------------------

export const bulkPaymentsPayrollServiceEndPoints = {
  get gxLookupType() {
    return `${u().bulkPaymentsPayrollServiceConfig}payments/bulk/gx-lookups`;
  },
  get gxViewFileformat() {
    return `${u().bulkPaymentsPayrollServiceConfig}payments/bulk/files/type/list`;
  },
  get gxBulkFileUpload() {
    return `${u().bulkPaymentsPayrollServiceConfig}payments/bulk/files/upload`;
  },
  get gxPayrollDebitAccounts() {
    return `${u().bulkPaymentsPayrollServiceConfig}payments/payroll/debit-accounts`;
  },
  get gxPaymentsBulkViewSummary() {
    return `${u().bulkPaymentsPayrollServiceConfig}payments/bulk/files/view-summary`;
  },
  get gxPayrollViewSummary() {
    return `${u().bulkPaymentsPayrollServiceConfig}payments/payroll/files/view-summary`;
  },
  get gxBulkDownloadTemplate() {
    return `${u().bulkPaymentsPayrollServiceConfig}payments/bulk/templates/export`;
  },
  get gxPaymentsBulkmoduleType() {
    return `${u().bulkPaymentsPayrollServiceConfig}payments/bulk/files/status/list`;
  },
  get gxPaymentsBulkReviewTransactionViewSummary() {
    return `${u().bulkPaymentsPayrollServiceConfig}payments/bulk/files/view`;
  },
  get gxPaymentsBulkReviewTransactionByStatus() {
    return `${u().bulkPaymentsPayrollServiceConfig}payments/bulk/files/transactions/view-summary`;
  },
  get gxPaymentsBulkTransactionDetails() {
    return `${u().bulkPaymentsPayrollServiceConfig}payments/bulk/files/transactions/view`;
  },
  get gxPayrollReviewTransactionViewSummary() {
    return `${u().bulkPaymentsPayrollServiceConfig}payments/payroll/files/view`;
  },
  get gxPayrollBulkTransactionByStatus() {
    return `${u().bulkPaymentsPayrollServiceConfig}payments/payroll/files/transactions/view-summary`;
  },
  get gxPayrollTransactionDetails() {
    return `${u().bulkPaymentsPayrollServiceConfig}payments/payroll/files/transactions/view`;
  },
  get gxPaymentsBulkSubmit() {
    return `${u().bulkPaymentsPayrollServiceConfig}payments/bulk/files/submit`;
  },
  get gxPayrollSubmit() {
    return `${u().bulkPaymentsPayrollServiceConfig}payments/payroll/files/submit`;
  },
  get gxPaymentsBulkReject() {
    return `${u().bulkPaymentsPayrollServiceConfig}payments/bulk/files/reject`;
  },
  get gxPayrollReject() {
    return `${u().bulkPaymentsPayrollServiceConfig}payments/payroll/files/reject`;
  },
  get gxPaymentsBulkTransactionDetailDownload() {
    return `${u().bulkPaymentsPayrollServiceConfig}payments/bulk/files/download`;
  },
  get gxPaymentsBulkApprovalViewSummary() {
    return `${u().bulkPaymentsPayrollServiceConfig}payments/bulk/pending/view-summary`;
  },
  get gxPayrollBulkApprovalViewSummary() {
    return `${u().bulkPaymentsPayrollServiceConfig}payments/payroll/pending/view-summary`;
  },
  get gxBulkPayrollListFileApproval() {
    return `${u().bulkPaymentsPayrollServiceConfig}payments/payroll/files/approve`;
  },
  get gxBulkPaymentsListFileApproval() {
    return `${u().bulkPaymentsPayrollServiceConfig}payments/bulk/files/approve`;
  },
  get gxNonce() {
    return `${u().bulkPaymentsPayrollServiceConfig}payments/bulk/nonce/initiate`;
  },
  get gxBulkFilesRetry() {
    return `${u().bulkPaymentsPayrollServiceConfig}payments/bulk/files/retry`;
  },
};

// ----------------------------userSettingsServiceEndPoints-------------------------------------

export const userSettingsServiceEndPoints = {
  get gxUserSettingsUpdate() {
    return `${u().settingsUrlConfig}customers/auth/idp/usersettings/update`;
  },
};

// ----------------------------directDebits-------------------------------------

export const directDebits = {
  get gxDirectDebitAccounts() {
    return `${u().rtpServiceUrlConfig}collections/payee/direct-debits/accounts`;
  },
  get gxDirectDebitMandates() {
    return `${u().rtpServiceUrlConfig}collections/payee/direct-debits`;
  },
  get gxMandateDetails() {
    return `${u().rtpServiceUrlConfig}collections/payee/direct-debits/view`;
  },
};

// ===================================================
// Settings - Alternative Dashboard
// ===================================================

export const alterNativeDashboardLayout = {
  get gxDashboardLayoutList() {
    return `${u().customerUrlConfig}customers/dashboard/layout/list`;
  },
  get gxDashboardLayoutView() {
    return `${u().customerUrlConfig}customers/dashboard/layout/view`;
  },
  get gxDashboardUpcomingPayments() {
    return `${u().paymentUrlConfig}payments/dashboard/upcoming/payments`;
  },
  get gxDashboardBalanceAccounts() {
    return `${u().accountServiceUrlConfig}accounts/alternate/balance`;
  },
  get gxDashboardPendingRepairViewSummary() {
    return `${u().paymentUrlConfig}payments/dashboard/pending/repair/view-summary`;
  },
  get gxDashboardPendingApprovalCount() {
    return `${u().paymentUrlConfig}payments/dashboard/pending/count`;
  },
  get gxDashboardPendingApprovalViewSummary() {
    return `${u().paymentUrlConfig}payments/dashboard/pending/approval/view-summary`;
  },
  get gxDashboardPendingRepairCount() {
    return `${u().paymentUrlConfig}payments/dashboard/pending/repair/count`;
  },
  get gxDashboardAccountsCashPosition() {
    return `${u().accountServiceUrlConfig}accounts/cash-position`;
  },
  get gxDashboardAccountsBalance() {
    return `${u().accountServiceUrlConfig}accounts/balance/accounts`;
  },
  get gxDashboardTodayApprovedCount() {
    return `${u().paymentUrlConfig}payments/dashboard/today/approved/count`;
  },
  get gxDashboardSpendCategory() {
    return `${u().paymentUrlConfig}payments/dashboard/spend/category`;
  },
  get gxDashboardAccountsMonthlyCashflow() {
    return `${u().accountServiceUrlConfig}accounts/monthly-cashflow`;
  },
};
